import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {signInAnonymously, updateProfile} from "firebase/auth";
import {FireBaseAuth} from "@/plugins/firebase";

export const useUserStore = defineStore('user', () => {
  const currentUser = ref(null)
  const showUserNameDialog = ref(false)
  const userName = ref("")
  const loading = ref(false)
  const randomName = [
    "Muhammad", "Noah", "Oliver", "Arthur", "Leo", "George", "Luca", "Theodore", "Oscar", "Archie",
    "James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Thomas", "Charles",
    "Jack", "Harry", "Charlie", "Alfie", "Freddie", "Theo", "Henry", "Jacob", "Lucas", "Adam",
    "Elijah", "Alexander", "Sebastian", "Julian", "Jasper", "Milo", "Felix", "Ezra", "Rowan", "Jude",
    "Hugo", "Reuben", "Tobias", "Simeon", "Elliott", "Xavier", "Phoenix", "Orion", "Caspian", "Finn", "Olivia",
    "Amelia", "Lily", "Isla", "Ivy", "Florence", "Freya", "Poppy", "Ava", "Elsie",
    "Mary", "Elizabeth", "Patricia", "Jennifer", "Linda", "Barbara", "Susan", "Margaret", "Dorothy", "Helen",
    "Isabella", "Sophia", "Mia", "Charlotte", "Emily", "Grace", "Ella", "Alice", "Sophie", "Evie",
    "Evelyn", "Aurora", "Violet", "Hazel", "Penelope", "Eleanor", "Ruby", "Iris", "Cora", "Maeve",
    "Juniper", "Lyra", "Wren", "Ophelia", "Elodie", "Margot", "Mabel", "Bonnie", "Ada", "Ottilie"
  ];

  async function generateRandomUserName() {
    const idx = Math.floor(Math.random() * randomName.length)
    return randomName[idx]
  }

  async function regenerateUserName() {
    userName.value = await generateRandomUserName()
  }

  function changeCurrentUser(user) {
    currentUser.value = user
    if (!user) {
      showUserNameDialog.value = true
      regenerateUserName()
    } else {
      showUserNameDialog.value = false
      userName.value = user.displayName
    }
  }

  const currentUserUid = computed(() => currentUser.value?.uid)

  async function loginWithoutRegister() {
    loading.value = true
    try {
      const name = userName.value
      const res = await signInAnonymously(FireBaseAuth)
      await updateProfile(res.user, {
        displayName: name,
        photoURL: "https://randomuser.me/api/portraits/lego/1.jpg"
      })
      changeCurrentUser(res.user)
      showUserNameDialog.value = false
    } catch (e) {
      console.log(e)
    }
    loading.value = false

  }

  return {
    currentUser,
    currentUserUid,
    showUserNameDialog,
    changeCurrentUser,
    regenerateUserName,
    userName,
    loading,
    loginWithoutRegister,
  }
})
